import { Injectable } from '@angular/core';
import { map, switchMap, concatMap } from 'rxjs';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as widgetActions from '../actions/pma-document-centre.actions';
import { PmaDocumentCentreWidgetHttpService } from
  '@feature/pma-document-centre/services/pma-document-centre-widget-http.service';

@Injectable()
export class PmaDocumentCentreWidgetEffects {

  constructor(
    private readonly pmaDocumentCentreWidgetHttp: PmaDocumentCentreWidgetHttpService,
    private readonly actions: Actions,
  ) { }

  load = createEffect(() => this.actions.pipe(
    ofType(widgetActions.apiLoad),
    concatMap(action =>
      this.pmaDocumentCentreWidgetHttp.getWidgetTableData({
        DashboardIdentifier: action.dashboardIdentifier,
        Limit: action.limit,
        WidgetInstanceId: action.widgetId,
        EntityKey: action.entityKey,
        IncludeParents: action.includeParents,
        IncludeChildren: action.includeChildren,
      }).pipe(map(data => {
        return widgetActions.apiLoadComplete({ widgetId: action.widgetId, data: data });
      }))
    )
  )
  );

}
